import api from "../../providers/api";
import history from "../../providers/history";
import { GetObject } from "../../providers/storage";
import { IAuthenticatedUser } from "../authentication/types";
import { IUserFilter, IUserSaveRequestPayload } from "./types";

export const usersListRequestService = (filter?: IUserFilter) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');
    
    let stringFilter = new URLSearchParams({
        name: filter?.name || '',
        email: filter?.email || '',
        password: filter?.password || '',
        page: String(filter?.page || 1),
        perPage: String(filter?.perPage || 10)
    }).toString();

    return api.get(`users/?${stringFilter}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const usersSaveRequestService = (users: IUserSaveRequestPayload, id?:string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    if (id) {
        return api.put(`users/${id}`, users, {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
    }

    return api.post('users/create', users, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const usersRemoveRequestService = ( usersId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');
    
    return api.delete(`users/${usersId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
} 